import { useAuthStore } from '../../store/authStore';

function readResponsavelIdFromJwt(): string {
  try {
    const token =
      sessionStorage.getItem('ac_token') || localStorage.getItem('ac_token') || '';
    const payload = token.split('.')[1];
    if (!payload) return '';
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return String(json?.responsavelId || '').trim();
  } catch {
    return '';
  }
}

/**
 * ID da tabela `responsaveis` — NUNCA usar `user.id` (usuario) como fallback:
 * a API mobile valida ownership JWT.responsavelId === param e devolve 403,
 * a UI interpreta como “nenhum filho”.
 */
export function useResponsavelId(): string {
  const user = useAuthStore((s) => s.user);
  const fromUser = String(
    (user as { responsavelId?: string | null } | null)?.responsavelId || '',
  ).trim();
  return fromUser || readResponsavelIdFromJwt();
}
